"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Provider = exports.Consumer = void 0;
var _react = _interopRequireDefault(require("react"));
var _React$createContext = /*#__PURE__*/_react["default"].createContext({}),
  Provider = _React$createContext.Provider,
  Consumer = _React$createContext.Consumer;
exports.Consumer = Consumer;
exports.Provider = Provider;